// TODO: Would be nice to read this from nuxt config (schemaOrg.identity.name), but not sure how.
export const COMPANY_NAME = "Aschehoug";

export function withCompanyPrefix(title: string | undefined | null) {
  return title ? [COMPANY_NAME, title].filter(truthy).join(" - ") : undefined;
}
